class FlagshipProductAdv {
  constructor(sectionElement) {
    this.section = sectionElement;
    this.sectionId = this.section.dataset.sectionId;
    
    // Parse Product Data
    this.productData = JSON.parse(this.section.querySelector('[data-product-json]').textContent);
    this.productOptions = JSON.parse(this.section.querySelector('[data-options-json]').textContent);
    
    // Parse Inventory Data (Added Fix)
    this.inventoryData = JSON.parse(this.section.querySelector('[data-inventory-json]').textContent);

    // Initial State
    this.currentVariantId = this.productData[0].id;
    this.selectedOptions = {};
    this.initSelectedOptions();
    
    // Elements
    this.variantButtons = this.section.querySelectorAll('.flagship-adv__var-opt');
    this.qtyButtons = this.section.querySelectorAll('.flagship-adv__qty-btn');
    this.toast = this.section.querySelector('.flagship-adv__toast');
    
    // Bind Methods
    this.handleVariantChange = this.handleVariantChange.bind(this);
    this.handleQtyChange = this.handleQtyChange.bind(this);
    this.handleToast = this.handleToast.bind(this);
    
    // Initialization
    this.addEventListeners();
    this.initMobileGallery();
    this.initStickyBar();
    this.initLightbox();
    this.subscribeToCartEvents();

    // Apply inventory rules for initial variant (Added Fix)
    const initialVariant = this.productData.find(v => v.id === this.currentVariantId);
    if (initialVariant) {
      this.updateQtyRules(initialVariant);
      this.updateInventoryStatus(initialVariant); // Initialize status
    }
  }

  initSelectedOptions() {
    this.section.querySelectorAll('.flagship-adv__var-group').forEach((group, index) => {
      const selectedBtn = group.querySelector('.selected');
      if (selectedBtn) {
        this.selectedOptions[this.productOptions[index]] = selectedBtn.dataset.value;
      }
    });
  }

  addEventListeners() {
    // Variants
    this.variantButtons.forEach(btn => {
      btn.addEventListener('click', (e) => this.handleVariantChange(e.target));
    });

    // Quantity
    this.qtyButtons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        const change = parseInt(e.target.dataset.qtyChange);
        this.handleQtyChange(e.target, change);
      });
    });

    // Sticky Bar Trigger
    const stickyTrigger = this.section.querySelector('[data-trigger-atc]');
    if (stickyTrigger) {
      stickyTrigger.addEventListener('click', () => {
        const mobFormBtn = this.section.querySelector('.flagship-adv__info-mobile button[type="submit"]');
        if (mobFormBtn) mobFormBtn.click();
      });
    }
  }

  handleVariantChange(element) {
    const optionName = element.dataset.optionName;
    const value = element.dataset.value;
    
    // UI Update
    const container = element.closest('.flagship-adv__var-group');
    container.querySelectorAll('.flagship-adv__var-opt').forEach(el => el.classList.remove('selected'));
    element.classList.add('selected');

    // State Update
    this.selectedOptions[optionName] = value;
    
    // Match Variant
    const matchedVariant = this.productData.find(variant => {
      return variant.options.every((val, index) => {
        const key = this.productOptions[index];
        return this.selectedOptions[key] === val;
      });
    });

    if (matchedVariant) {
      this.currentVariantId = matchedVariant.id;
      this.updateForms(matchedVariant);
      this.updatePrice(matchedVariant);
      this.updateSku(matchedVariant);
      this.updateUrl(matchedVariant);
      this.updateQtyRules(matchedVariant);
      this.updateInventoryStatus(matchedVariant); // Update status on change
    }
  }

  updateForms(variant) {
    // Update hidden inputs in all forms (desktop, mobile, sticky) within this section
    const inputs = this.section.querySelectorAll('.flagship-adv__variant-id');
    inputs.forEach(input => {
      input.value = variant.id;
      // Dispatch event so other listeners know it changed
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePrice(variant) {
    const prices = this.section.querySelectorAll('.flagship-adv__price-text');
    prices.forEach(price => price.innerText = this.formatMoney(variant.price));
  }

  updateSku(variant) {
    const skus = this.section.querySelectorAll('.flagship-adv__sku');
    skus.forEach(sku => sku.innerText = variant.sku || '');
  }

  updateUrl(variant) {
    const newUrl = new URL(window.location);
    newUrl.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', newUrl);
  }

  // Update Inventory Status Logic
  updateInventoryStatus(variant) {
    const elements = this.section.querySelectorAll('.flagship-adv__inventory');
    const inventoryInfo = this.inventoryData[variant.id];
    
    elements.forEach(el => {
      const textSpan = el.querySelector('.flagship-adv__inventory-text');
      
      // Check logic: Available AND Quantity > 0 AND Quantity < 4
      if (variant.available && inventoryInfo && inventoryInfo.quantity > 0 && inventoryInfo.quantity < 4) {
        el.classList.remove('hidden');
        if (textSpan) textSpan.innerText = `Only ${inventoryInfo.quantity} Left`;
      } else {
        el.classList.add('hidden');
      }
    });
  }

  updateQtyRules(variant) {
    const qtyInputs = this.section.querySelectorAll('.flagship-adv__qty-input');
    const inventoryInfo = this.inventoryData[variant.id];
    
    qtyInputs.forEach(input => {
      if (inventoryInfo && inventoryInfo.management === 'shopify' && inventoryInfo.policy === 'deny') {
        const max = inventoryInfo.quantity;
        input.setAttribute('max', max);
        // If current val > max, clamp it immediately
        if (parseInt(input.value) > max) {
          input.value = max > 0 ? max : 1; 
        }
      } else {
        input.removeAttribute('max');
      }
    });
  }

  handleQtyChange(btn, change) {
    const container = btn.closest('.flagship-adv__qty');
    const input = container.querySelector('input');
    let val = parseInt(input.value) + change;
    
    // Check Max
    const max = input.getAttribute('max');
    if (max && val > parseInt(max)) {
      val = parseInt(max);
    }
    
    // Check Min
    if (val < 1) val = 1;

    input.value = val;
    // Dispatch event so product-form.js or others pick up the change
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  formatMoney(cents) {
    return "$" + (cents / 100).toFixed(2); 
  }

  // --- PUB/SUB FOR DAWN ---
  subscribeToCartEvents() {
    if (window.PUB_SUB_EVENTS && window.subscribe) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event.source === 'product-form' && this.section.contains(event.target)) { // Only if triggered from this section
           this.handleToast();
        } else if (event.source === 'product-form') {
           // Fallback if event target isn't passed correctly
           this.handleToast();
        }
      });
    }
  }

  handleToast() {
    if (!this.toast) return;
    this.toast.classList.add('show');
    setTimeout(() => {
      this.toast.classList.remove('show');
    }, 3000);
  }

  // --- MOBILE GALLERY LOGIC ---
  initMobileGallery() {
    const gallery = this.section.querySelector('[data-gallery-mobile]');
    const counter = this.section.querySelector('[data-mob-counter]');
    const navBtns = this.section.querySelectorAll('[data-mob-scroll]');
    
    if (!gallery) return;

    // Scroll Listener for Counter
    gallery.addEventListener('scroll', () => {
      const scrollLeft = gallery.scrollLeft;
      const width = gallery.offsetWidth;
      const index = Math.round(scrollLeft / width);
      const total = this.productData[0].featured_media ? this.productData.length : gallery.childElementCount; // approx
      if (counter) counter.innerText = (index + 1) + " / " + gallery.children.length;
    });

    // Arrow Buttons
    navBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        const direction = parseInt(e.target.dataset.mobScroll);
        const width = gallery.offsetWidth;
        const currentScroll = gallery.scrollLeft;
        const currentIndex = Math.round(currentScroll / width);
        let nextIndex = currentIndex + direction;
        
        // Loop
        if (nextIndex < 0) nextIndex = gallery.children.length - 1;
        if (nextIndex >= gallery.children.length) nextIndex = 0;

        gallery.scrollTo({ left: nextIndex * width, behavior: 'smooth' });
      });
    });
  }

  // --- STICKY BAR LOGIC ---
  initStickyBar() {
    const bar = this.section.querySelector('[data-sticky-bar]');
    if (!bar) return;

    document.addEventListener('scroll', () => {
      if (window.innerWidth > 767) return;
      const mobBtn = this.section.querySelector('.flagship-adv__info-mobile button[type="submit"]');
      if (!mobBtn) return;
      
      const rect = mobBtn.getBoundingClientRect();
      if (rect.bottom < 0) {
        bar.classList.add('visible');
      } else {
        bar.classList.remove('visible');
      }
    });
  }

  // --- LIGHTBOX LOGIC ---
  initLightbox() {
    this.lightbox = this.section.querySelector('[data-lightbox]');
    this.track = this.section.querySelector('[data-lightbox-track]');
    this.zoomIndex = 0;
    
    // Open Triggers
    const triggers = this.section.querySelectorAll('[data-open-zoom]');
    triggers.forEach(t => {
      t.addEventListener('click', () => {
        this.zoomIndex = parseInt(t.dataset.openZoom);
        this.openZoom();
      });
    });

    // Close
    const closeBtn = this.section.querySelector('[data-close-zoom]');
    if (closeBtn) closeBtn.addEventListener('click', () => this.closeZoom());
    
    if (this.lightbox) {
      this.lightbox.addEventListener('click', (e) => {
        if (e.target === this.lightbox) this.closeZoom();
      });
    }

    // Nav
    const navBtns = this.section.querySelectorAll('[data-zoom-nav]');
    navBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        const dir = parseInt(e.target.dataset.zoomNav);
        this.changeSlide(dir);
      });
    });

    // Keyboard
    this.handleKeydown = this.handleKeydown.bind(this);
  }

  openZoom() {
    this.updateTrack();
    this.lightbox.classList.add('active');
    document.addEventListener('keydown', this.handleKeydown);
  }

  closeZoom() {
    this.lightbox.classList.remove('active');
    document.removeEventListener('keydown', this.handleKeydown);
  }

  changeSlide(dir) {
    this.zoomIndex += dir;
    const total = this.track.children.length;
    if (this.zoomIndex < 0) this.zoomIndex = total - 1;
    if (this.zoomIndex >= total) this.zoomIndex = 0;
    this.updateTrack();
  }

  updateTrack() {
    this.track.style.transform = `translateX(-${this.zoomIndex * 100}%)`;
  }

  handleKeydown(e) {
    if (e.key === 'Escape') this.closeZoom();
    if (e.key === 'ArrowLeft') this.changeSlide(-1);
    if (e.key === 'ArrowRight') this.changeSlide(1);
  }
}

// Initialize on Load and Theme Editor changes
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.flagship-adv__wrapper').forEach(el => new FlagshipProductAdv(el));
});

document.addEventListener('shopify:section:load', (e) => {
  const el = e.target.querySelector('.flagship-adv__wrapper');
  if (el) new FlagshipProductAdv(el);
});